import Cookies from 'js-cookie'
import Vue from 'vue'

export const write = (key, value, expiresDays = 1) => {
    const source = Vue.prototype.GLOBAL.source
    Cookies.set(`${source}_${key}`, value, {
        expires: expiresDays,
        path: '/',
    })
}

export const get = (key) => {
    const source = Vue.prototype.GLOBAL.source
    return Cookies.get(`${source}_${key}`)
}

export const remove = (key) => {
    const source = Vue.prototype.GLOBAL.source
    Cookies.remove(`${source}_${key}`, {
        path: '/'
    })
}
